import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import { useNavigate } from 'react-router-dom';

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const navigate = useNavigate();

  const services = [
    {
      id: 'architecture',
      name: 'ARCHITECTURAL DESIGN',
      description:'We don’t just design buildings—we create meaningful spaces. Our architectural solutions are modern, sustainable, and tailored to meet your vision, ensuring form and function go hand in hand.' },
    {
      id: 'interior',
      name: 'INTERIOR DESIGN',
      description: 'Where style meets functionality. Our interior designs reflect your personality, optimize space usage, and transform every room into a place you truly feel at home.',
    },
    {
      id: 'planning',
      name: 'Turnkey Project Management',
      description: 'Sit back and relax—we handle it all. From concept to completion, our turnkey solutions cover every detail of your project, ensuring smooth execution and on-time delivery.',
    },
    {
      id: 'landscape',
      name: 'LANDSCAPE SOLUTIONS',
      description: 'Nature, beautifully integrated. We design green spaces that bring harmony to your environment, adding tranquility, aesthetic value, and a natural balance to your surroundings.',
    },
    {
      id: '3d',
      name: '3D DESIGNING',
      description: 'Experience your space before its built. Our photorealistic 3D renderings allow you to visualize materials, lighting, and layout in detail—bringing your ideas to life with clarity and precision.',
    },
    {
      id: 'modular',
      name: 'Modular Furniture',
      description: 'Smart, flexible, and future-ready. Our modular furniture solutions are customizable and space-efficient—perfect for evolving needs and modern lifestyles.',
    },
    {
      id: 'PVC Modular Solutions',
      name: 'PVC MODULAR SOLUTIONS',
      description: 'Durable, low-maintenance, and stylish. Our PVC modular designs are ideal for long-lasting, eco-friendly interiors with a sleek, modern finish.',
    },
    {
    id: 'Industrial Buildings',
    name:'INDUSTRIAL BUILDINGS',
    description:'Efficiency meets design. We create industrial facilities that prioritize structural performance, operational flow, and long-term functionality without compromising on aesthetic value.',
  
  }
    
  ];

  const handleServiceClick = (service) => {
    navigate('/services');
  };

  const handleBackClick = () => {
    setSelectedService(null);
  };

  if (selectedService) {
    return (
      <section id="services" className="section services-detail">
        <div className="container">
          <motion.button 
            className="back-btn"
            onClick={handleBackClick}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            ← Back to Services
          </motion.button>

          <motion.div 
            className="service-detail-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="service-detail-header">
              <h2>Services We Provide</h2>
            </div>

            <div className="service-detail-grid">
              {services.map((service, index) => (
                <motion.div 
                  key={service.id}
                  className="service-detail-card"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <h3>{service.name}</h3>
                  <p>{service.description}</p>
                </motion.div>
              ))}
            </div>

            <div className="service-images">
              <div className="image-row">
                <div className="service-image">
                  <img src={services[0].image} alt="Architectural Design" />
                </div>
                <div className="service-image">
                  <img src={services[1].image} alt="Interior Design" />
                </div>
              </div>
              <div className="image-row">
                <div className="service-image">
                  <img src={services[2].image} alt="Space Planning" />
                </div>
                <div className="service-image">
                  <img src={services[3].image} alt="Landscape Solutions" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    );
  }

  return (
    <section id="services" className="section services">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2>Services</h2>
        </motion.div>

        <motion.div 
          className="services-list services-grid"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {services.map((service, index) => (
            <motion.div 
              key={service.id} 
              className="service-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              onClick={() => handleServiceClick(service)}
            >
              <span className="service-name">{service.name}</span>
              <span className="service-arrow">▸</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services; 